import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import SEO from './SEO';
import Helmet from 'react-helmet';
import * as styles from './Styles/homepage.module.scss';
import Footer from './Shared/Footer';
import {Link} from 'gatsby';
import {Container} from 'react-bootstrap';
import Header from './Shared/Header';
import htmr from 'htmr';
import '../styles/cookieconsent.min.css';
import * as utils from './Shared/Utils';
import AssetsService from '../Application/Shared/AssetsService';
import UtmService from './Services/UtmService';
import loadable from '@loadable/component';
const Carousel=loadable(() => import('react-multi-carousel'));
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import SubscribeBanner from './Shared/SubscribeBanner';
import SocialShare from './Shared/SocialShare';
import ReactPlayer from 'react-player';
import {showVideoPreviewOnCoursePage} from
  '../components/Configuration/ApplicationConfig';
import CourseVideoPreviewHomePage from './Shared/CourseVideoPreviewHomePage';
// import cookie from 'react-cookies';

/**
  * @param {object} coursePageData
  * @return {object} CoursePage
  */
function HomePageComponent({
  headerContent,
  footerContent,
  homePageData,
  cataloguePageData,
  languageCanonicals,
  siteMetadata,
  imageData,
}) {
  const locale=homePageData.locale;
  const wideAssetsService = new AssetsService('WEBSITE_WIDE');
  const squareAssetsService = new AssetsService('WEBSITE_SQUARE');
  const [loadComponent, setLoadComponent] = useState(false);
  const signupUrl = ['en', 'en-us', 'en-gb'].includes(locale) ?
  `/signup/` : `/${locale}/signup/`;
  const loginUrl = ['en', 'en-us', 'en-gb', 'en-in'].includes(locale) ?
  `/learner/en/login/` : `/learner/${locale}/login/`;
  const [activeCourse, setActiveCourse] = useState('');
  // const countryCode = cookie.load('geotargetly_country_code');

  const [currentPlayingVideo, setCurrentPlayingVideo] = useState(null);
  const trustpilotRef = useRef(null);

  const handleScroll = () => {
    if (typeof window !== 'undefined' && window.scrollY > 100) {
      const images = document.getElementsByTagName('img');
      Array.from(images).forEach((img) => {
        if (img.dataset.src && img.src.indexOf(img.dataset.src) <= -1) {
          img.src = img.dataset.src;
        }
      });
      if (!loadComponent) {
        setLoadComponent(true);
      }
    }
  };

  useEffect(() => {
    const utmService=new UtmService();
    utmService.init();
    const trackingObj = {
      pageKind: 'WebsiteHomePage',
      locale: homePageData.locale,
      courseSlug: '',
      facultySlug: '',
    };
    utils.trackPageView(trackingObj);
    utils.setChatBotVisibility(false);
    utils.initializePrices();
    window.addEventListener('scroll', handleScroll);
    initTrustpilot();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const initTrustpilot = () => {
    if (trustpilotRef.current && window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustpilotRef.current, true);
    }
  };

  const ButtonGroup = (button) => {
    const {carouselState: {currentSlide,
      totalItems, slidesToShow}} = button;
    const isEndOfList = currentSlide>=totalItems-slidesToShow;
    return (
      <div className={styles.carousalButtongroup}>
        <p className={`${styles.prev} ${!currentSlide && styles.disable}`}
          onClick={() => button.previous()}>{button.prevText}</p>
        <p className={`${styles.next} ${isEndOfList && styles.disable}`}
          onClick={() => button.next()}>{button.nextText}</p>
      </div>
    );
  };

  const canonicalList=homePageData.seo.canonicalurls;
  const canonicalUrls=[];
  if (canonicalList) {
    for (let index=0; index<canonicalList.length; index++) {
      canonicalUrls.push({
        'href': canonicalList[index].href,
        'rel': 'canonical',
      });
    }
  }

  const responsive = {
    desktop: {
      breakpoint: {max: 3000, min: 1024},
      slidesToSlide: 3,
      items: 3,
    },
    tablet: {
      breakpoint: {max: 1024, min: 768},
      slidesToSlide: 2,
      items: 2,
    },
    mobile: {
      breakpoint: {max: 768, min: 0},
      slidesToSlide: 1,
      items: 1,
    },
  };

  return (
    <div>
      <SEO
        locale={homePageData.locale}
        title={homePageData.seo.title}
        description={homePageData.seo.description}
        canonicalUrls={canonicalUrls}
        languageCanonicals={languageCanonicals}
        siteMetadata={siteMetadata}
        schemaMarkup={JSON.parse(homePageData.schema)}
      />
      <Helmet>
        <script>
          window.dataLayer=window.dataLayer||[];
        </script>
      </Helmet>
      <Helmet>
        <script async src="/js/cookieconsent-scripts.min.js"></script>
      </Helmet>
      <Helmet>
        <script type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async>
        </script>
      </Helmet>

      <Header headerContent={headerContent}
        isHomepage={true} locale={homePageData.locale}/>
      <main className={styles.homePage}>
        <div ></div>
        {homePageData.sections.map((section, sectionIndex) => {
          let content= '<div></div>';
          if (section.pagesection) {
            content=section.pagesection.content;
          }
          if (section.herosection) {
            return (
              <div key={`section-${sectionIndex}`}
                className={styles.gradientBg}>
                {!showVideoPreviewOnCoursePage && <ReactPlayer
                  style={{minWidth: '250px'}}
                  width='100%'
                  height='auto'
                  url={'/images/home/video/banner-video.mp4'}
                  playing={true}
                  loop={true}
                  muted={true}
                />}
                <Container key={`section-${sectionIndex}`}>
                  <div className={styles.newHomeBanner}>
                    <div className={styles.bannerContent}>
                      <div className={styles.contentHead}>
                        <h1>{section.herosection.heading}</h1>
                        <h2>{section.herosection.subheading}</h2>
                      </div>
                      <div className={styles.contentInfo}>
                        <p>{section.herosection.description}</p>
                      </div>
                      <div ref={trustpilotRef}
                        className={`trustpilot-widget ${
                          styles.trustpilotWidget
                        }`}
                        data-locale="en-US"
                        data-template-id="53aa8807dec7e10d38f59f32"
                        data-businessunit-id="6194a9df58af49f369c74f47"
                        data-style-height="120px" data-style-width="250px">
                        <a href="https://www.trustpilot.com/review/upskillist.com" target="_blank" rel="noopener noreferrer">Trustpilot</a>
                      </div>
                      <div className={styles.bannerCta}>
                        <Link className={styles.startLearnCta} to='/courses/'
                          rel="noindex, nofollow">
                          {/* {countryCode=='us' ? 'Enroll Now' :
                          `${section.herosection.signupcta}`} */}
                          {section.herosection.signupcta}
                        </Link>
                        <a className={styles.tryEnterpriseCta}
                          href='https://www.upskillist.pro/?utm_medium=referral&utm_source=upskillist.com&utm_campaign=home_page_hero_banner'
                          target="_blank"
                          rel="external noreferrer">
                          {section.herosection.enterprisecta}
                        </a>
                      </div>
                      <div className={styles.existingUserLogin}>
                        {section.herosection.existinguser}&nbsp;
                        <Link className={styles.loginCta}
                          to={loginUrl}>{section.herosection.logincta}</Link>
                      </div>
                    </div>
                    <div className={styles.bannerImg} >
                      <img className={styles.hideOnMobile}
                        // eslint-disable-next-line react/no-unknown-property
                        fetchpriority="high"
                        src="/images/home/new/brand-desktop.webp"
                        width="460" height="615" alt="hero-banner" />
                      <img className={styles.showOnMobile}
                        // eslint-disable-next-line react/no-unknown-property
                        fetchpriority="high"
                        src="/images/home/new/brand-mobile.webp"
                        width="311" height="268" alt="hero-banner" />
                    </div>
                  </div>
                </Container>
              </div>
            );
          }

          if (section.courselistblock) {
            return (
              <React.Fragment key={`section-${sectionIndex}`}>
                <div className={styles.newHomeSkills}>
                  <Container className={styles.container}>
                    <section className={styles.popularCourseContainer}>
                      <div className={styles.popularHeader}>
                        <h2>We’ve got</h2>
                        <div className={styles.ViewAllCourses}>
                          <h3>Just the thing for you.</h3>
                          <Link to='/courses'
                            className={`${styles.blueLargeCta
                            } library-brand-icon-new`}>
                              View all courses
                            <i className="icon-new-Open-arrow"></i>
                          </Link>
                        </div>
                      </div>
                      <div className={styles.contentRow}>
                        {section.courselistblock.courselist
                            .filter((course, index) => index < 6)
                            .map((course, index) => {
                              const previewVideo =
                                course.coursepreviewvideo.href;
                              const courseId = course.courseslug;
                              const signupURL = utils
                                  .getLocalizedSignupLink(locale, courseId);
                              // const courseSignupLinkUS=
                              //     utils.getLocalizedSignupLinkUS(
                              //         locale, courseId);
                              const courseURL = utils
                                  .getLocalizedPageLink(locale, course.url);
                              const wideImage = wideAssetsService
                                  .fetchAssetURL(courseId);
                              const squareImage = squareAssetsService
                                  .fetchAssetURL(courseId);
                              const currentCourseImageNode =
                              imageData.nodes.filter((
                                  node) => (
                                node.Key.includes(courseId)
                              ),
                              )[0];
                              const courseImage = currentCourseImageNode &&
                            currentCourseImageNode.localFile &&
                            getImage(
                                currentCourseImageNode.localFile.
                                    childImageSharp.gatsbyImageData);
                              return (
                                <div key={index}
                                  className={styles.popularCard}>
                                  <div className={styles.cardBox}>
                                    {showVideoPreviewOnCoursePage &&
                                      previewVideo ?
                                      <CourseVideoPreviewHomePage
                                        courseImage={courseImage}
                                        previewVideo={previewVideo}
                                        signupLink={signupURL}
                                        courseSlug={courseId}
                                        currentPlayingVideo={
                                          currentPlayingVideo
                                        }
                                        setCurrentPlayingVideo={
                                          setCurrentPlayingVideo
                                        } /> :
                                      <div className={styles.popularCardImg}>
                                        <Link
                                          to={courseURL}>
                                          <GatsbyImage
                                            image={courseImage}
                                            alt={courseId}
                                          />
                                        </Link>
                                      </div>}
                                    <div className={styles.popCardContent}>
                                      <div className={styles.cardInfo}>
                                        <div className={styles.popCourseName}>
                                          <Link
                                            to={courseURL}>
                                            {course.coursemenuname
                                                ?.replace(/(.{45})..+/, '$1…')}
                                          </Link>
                                          <SocialShare
                                            key={index}
                                            courseUrl={courseURL}
                                            courseName={course.coursemenuname}
                                            activeCourse={activeCourse}
                                            setActiveCourse={setActiveCourse}/>
                                        </div>
                                        <div className={styles.ratingContent}>
                                          <div className=
                                            {styles.popEnrollCount}>
                                            {course.graduates?.toLocaleString()}
                                            &nbsp;
                                            {section.courselistblock?.
                                                graduatestext}
                                          </div>
                                          {
                                          /* <div className={styles.starRating}>
                                            <span>{course.rating/10}</span>
                                            <img
                                              width={15}
                                              height={15}
                                              src=
                                                "/images/home/new/star.svg"
                                              alt="" />
                                          </div> */}
                                        </div>
                                      </div>
                                      <div className={styles.popEnrollContent}>
                                        {/* Master the skill of image editing &
                                    take your photos to the next level
                                    in 4 weeks. */}
                                        <p>{course.coursecarddescription}</p>
                                      </div>
                                      <div className={styles.popEnrollSection}>
                                        {/* {countryCode=='us'? <Link
                                          to={courseSignupLinkUS}
                                          className={styles.popEnrollCta}
                                          rel="noindex nofollow">
                                          Enroll Now
                                        </Link> :  */}
                                        <Link
                                          to={signupURL}
                                          className={styles.popEnrollCta}
                                          rel="noindex nofollow">
                                          {section.courselistblock.enrollnowcta}
                                        </Link>
                                        {/* } */}
                                        <Link to={courseURL}
                                          className={styles.popMoreCta}
                                          rel="noindex nofollow">
                                          More info
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            } )}
                      </div>
                    </section>
                  </Container>
                </div>
              </React.Fragment>);
          }
          if (section.reviewslistblock) {
            return (
              <Container key={`seciton-${sectionIndex}`}>
                <div
                  className={styles.testimonySection}>
                  <div className={styles.testimonyTop}>
                    <div className={styles.testimonyHeadline}>
                      {section.reviewslistblock.heading}
                    </div>
                  </div>
                  {loadComponent && <Carousel
                    responsive={responsive}
                    arrows={false}
                    customButtonGroup={<ButtonGroup
                      prevText={section.reviewslistblock.prevtext}
                      nextText={section.reviewslistblock.nexttext} />}
                    className={styles.testimonyBody}>
                    {section.reviewslistblock.reviews.map((review, index) => (
                      <div key={index} className={styles.testimony}>
                        <div className={styles.testimonyImg}>
                          <img src="/images/transparent.png"
                            data-src={review.reviewerimage?.href}
                            alt={review.reviewerimage?.title} />
                          <div className={styles.rating}>
                            <p>{review.rating}</p>
                            <img src="/images/transparent.png"
                              data-src='/images/home/new/star.svg' alt='' />
                          </div>
                        </div>
                        <div className={styles.testimonyContent}>
                          {review.review}</div>
                      </div>
                    ))}
                  </Carousel>}
                </div>
              </Container>
            );
          }
          if (section.testimoniallistblock && false) {
            const testimonialList=section.testimoniallistblock.testimoniallist;
            return (
              <Container key={`seciton-${sectionIndex}`} className="">
                <div className={styles.newHomeReview}>
                  {loadComponent&& <Carousel
                    responsive={{
                      desktop: {
                        breakpoint: {max: 3000, min: 1024},
                        slidesToSlide: 1,
                        items: 1,
                      },
                      tablet: {
                        breakpoint: {max: 1024, min: 464},
                        slidesToSlide: 1,
                        items: 1,
                      },
                      mobile: {
                        breakpoint: {max: 464, min: 0},
                        slidesToSlide: 1,
                        items: 1,
                      },
                    }}
                    arrows={true}
                    className=""
                    customButtonGroup={<ButtonGroup
                      prevText={section.testimoniallistblock.prevtext}
                      nextText={section.testimoniallistblock.nexttext}
                    />} >
                    {testimonialList.map((testimonial, testimonialIndex) => (
                      <div key={testimonialIndex}
                        className={styles.newHomeReviewSection}>
                        <div className={styles.newHomeReviewSectionData}>
                          <p className={styles.reviewText}>
                            {testimonial.testimonialcontent}
                          </p>
                          <p className={styles.reviewName}>
                            <span>{testimonial.name},</span>
                            {testimonial.location}</p>
                          <p className={styles.reviewCourse}>
                            {testimonial.course}</p>
                        </div>
                        <div className={styles.newHomeReviewSectionImg}>
                          {testimonial.isimage?
                       <img src="/images/transparent.png"
                         data-src={testimonial.testimonialasset.href}
                         alt={testimonial.testimonialasset.title}/>:
                         <iframe className={styles.reviewIframe}
                           src={testimonial.testimonialasset.href}
                           width='100%' height='100%' >
                         </iframe>}
                        </div>
                      </div>
                    ))}
                  </Carousel>}
                </div>
              </Container>
            );
          }
          if (section.bloglistblock) {
            const blogResponsive = {
              desktop: {
                breakpoint: {max: 3000, min: 1025},
                slidesToSlide: 4,
                items: 4,
              },
              tablet: {
                breakpoint: {max: 1024, min: 768},
                slidesToSlide: 2,
                items: 2,
              },
              mobile: {
                breakpoint: {max: 768, min: 0},
                slidesToSlide: 1,
                items: 1,
              },
            };
            return (
              <div key={`section-${sectionIndex}`} className=
                {styles.educatorBlogs}>
                <Container className={styles.educatorHeader}>
                  <Link
                    to='/blog/'
                    className={styles.educatorHeader}>
                    <span className={styles.educatorHeaders}>
                      {section.bloglistblock.heading}
                    </span>
                  </Link>
                </Container>
                <Container>
                  <Carousel
                    responsive={blogResponsive}
                    arrows={false}
                    className={styles.blogCards}
                    customButtonGroup={<ButtonGroup
                      prevText={section.bloglistblock?.prevtext}
                      nextText={section.bloglistblock?.nexttext}
                    />} >
                    {section.bloglistblock.featuredblogs.map((blog, index) => (
                      <Link
                        key={index}
                        to={blog.url}
                        className={styles.blogCard}>
                        <div className={styles.blogCardImg}>
                          <img src="/images/transparent.png"
                            data-src={blog.featuredimage.href}
                            alt={blog.featuredimage.title} />
                        </div>
                        <div className={styles.blogCardDetails}>
                          <div className={styles.blogCardText}>
                            {blog.title}
                          </div>
                          <div className={styles.blogCardEnd}>
                            <div className={styles.blogCardTopic}>
                              {blog.category}
                            </div>
                            <div className={styles.blogDate}>
                              {blog.publisheddate}
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </Carousel>
                </Container>
              </div>
            );
          }
          return (<React.Fragment key={`section-${sectionIndex}`}>
            {htmr(content)}
          </React.Fragment>);
        })}
        <div className={styles.subscribeSection}>
          <Container className={styles.container}>
            <div className={styles.subscriberBannerContainer}>
              <SubscribeBanner />
            </div>
          </Container>
        </div>
      </main>

      <Footer
        footerData={footerContent}
        siteMetadata={siteMetadata}
      />
    </div>
  );
}

HomePageComponent.defaultProps = {
  homePageData: {},
  languageCanonicals: {},
};

HomePageComponent.propTypes = {
  headerContent: PropTypes.object,
  footerContent: PropTypes.object,
  homePageData: PropTypes.object,
  languageCanonicals: PropTypes.object,
  cataloguePageData: PropTypes.object,
  siteMetadata: PropTypes.object,
  imageData: PropTypes.object,
  isHomepage: PropTypes.bool,
};

export default HomePageComponent;
